"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PARAMETER_VISUALIZATION = exports.PARAMETER_TYPE = void 0;
const sdk_geometry_api_sdk_v2_1 = require("@shapediver/sdk.geometry-api-sdk-v2");
Object.defineProperty(exports, "PARAMETER_TYPE", { enumerable: true, get: function () { return sdk_geometry_api_sdk_v2_1.ResParameterType; } });
Object.defineProperty(exports, "PARAMETER_VISUALIZATION", { enumerable: true, get: function () { return sdk_geometry_api_sdk_v2_1.ResVisualizationType; } });
//# sourceMappingURL=types.js.map